<script>
import feather from 'feather-icons';
import FooterCopyright from './FooterCopyright.vue';
import { socialLinks } from '../../data/socialLinks';

export default {
	components: { FooterCopyright },
	data() {
		return {
			socials: socialLinks,
		};
	},
	mounted() {
		feather.replace();
	},
	updated() {
		feather.replace();
	},
};
</script>

<template>
	<div class="container mx-auto">
		<div class="hazard-stripe mt-16 sm:mt-24"></div>
		<div class="pt-20 sm:pt-30 pb-8 mt-8 sm:mt-10">
			<!-- Footer social links -->
			<div
				class="flex flex-col justify-center items-center mb-12 sm:mb-20"
			>
				<p
					class="font-display uppercase tracking-wide text-3xl sm:text-4xl font-bold text-primary-light mb-5"
				>
					Follow Us
				</p>
				<ul class="flex gap-4 sm:gap-8">
					<a
						v-for="social in socials"
						:key="social.id"
						:href="social.url"
						target="__blank"
						:aria-label="social.name"
						class="text-ternary-light hover:text-brand-500 hover:shadow-glow cursor-pointer clip-corner-sm bg-ternary-dark hover:bg-secondary-dark border border-ternary-dark shadow-sm p-4 duration-300"
					>
						<svg
							v-if="social.icon === 'google'"
							viewBox="0 0 24 24"
							fill="currentColor"
							class="w-5 sm:w-8 h-5 sm:h-8"
						>
							<path
								d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
							/>
						</svg>
						<i
							v-else
							:data-feather="social.icon"
							class="w-5 sm:w-8 h-5 sm:h-8"
						></i>
					</a>
				</ul>
			</div>

			<!-- Footer copyright -->
			<FooterCopyright />
		</div>
	</div>
</template>

<style scoped></style>
